export default {
  styleOverrides: {
    root: {
      // borderColor: grey[200],
    },
  },
};
